import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ShrugIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 6C9.10457 6 10 4.60457 10 3.5C10 2.39543 9.10457 1 8 1C6.89543 1 6 2.39543 6 3.5C6 4.60457 6.89543 6 8 6Z"
		></path>
		<path
			fill="currentColor"
			d="M6.89451 6.52756C7.16992 6.70498 7.53595 6.85125 8 6.89003C8.46405 6.85125 8.83008 6.70498 9.10549 6.52756L9.19414 6.47024C9.62744 6.18957 10.0936 5.88763 10.5992 5.88763C10.9774 5.88763 11.3402 6.04264 11.6077 6.31856L12.6622 7.40636L13.4719 5.31834C13.5684 5.06947 13.8362 4.94133 14.0827 5.02609L14.6643 5.22607C14.916 5.3126 15.0554 5.58973 14.9792 5.85181L14.0064 9.19662C13.8225 9.82913 13.1103 10.1136 12.5613 9.77388L11.1899 8.92508L11.6364 14.4517C11.6602 14.7469 11.4345 15 11.1473 15H4.85266C4.56555 15 4.33975 14.7469 4.3636 14.4517L4.81006 8.92508L3.43867 9.77388C2.88974 10.1136 2.17751 9.82913 1.99356 9.19662L1.02081 5.85181C0.944594 5.58973 1.08404 5.3126 1.33568 5.22607L1.91728 5.02609C2.16379 4.94133 2.43163 5.06947 2.52813 5.31834L3.33779 7.40636L4.39231 6.31856C4.65979 6.04264 5.02257 5.88763 5.40084 5.88763C5.90642 5.88763 6.37256 6.18957 6.80586 6.47024L6.89451 6.52756Z"
		></path>
	</svg>
))
